<template>
  <div>
    <h2>Programs</h2>
    <div class="description">View Programs</div>

    <div class="table">
      <div class="trow">
        <div class="thead name">Program Name</div>
        <div class="thead school-name">School Name</div>
        <div class="thead campus">Campus</div>
        <div class="thead tution-fee">Tution Fee</div>
        <div class="thead application-fee">Application Fee</div>
        <div class="thead september-intake">September</div>
        <div class="thead january-intake">January</div>
        <div class="thead may-intake">May</div>
        <div class="thead actions">Actions</div>
      </div>
      <div class="trow" v-for="program in allPrograms" :key="program.id">
        <div class="tdata name">{{ program.name }}</div>
        <div class="tdata school-name">{{ program.school_name }}</div>
        <div class="tdata campus">{{ program.school.campus }}</div>
        <div class="tdata tution-fee">{{ program.tution_fee }}</div>
        <div class="tdata application-fee">{{ program.application_fee }}</div>
        <div class="tdata september-intake">{{ program.september ? 'Yes' : 'No' }}</div>
        <div class="tdata january-intake">{{ program.january ? 'Yes' : 'No' }}</div>
        <div class="tdata may-intake">{{ program.may ? 'Yes' : 'No' }}</div>
        <div class="tdata actions">
          <router-link :to="`/admin/edit-program/${program.id}`">
            <v-button type="primary" size="small" class="edit-button">Edit</v-button>
          </router-link>
          <div>
            <v-button type="default" size="small" v-if="program.display_status" @click="() => hideProgram(program)">Hide on webapp</v-button>
            <v-button type="warning" size="small" v-if="!program.display_status" @click="() => showProgram(program)">Show on webapp</v-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

const ToggleSwitch = Vue.component('ToggleSwitch', {
  template: `
            <div style="margin-right:24px;">
              <b style="margin-right:6px;">{{label}}</b>
              <v-switch size="medium" :disabled="disabled" v-model="Boolean(model)">
                <span slot="checkedChildren" v-if="model">
                  <i class="anticon anticon-check"></i>
                </span>
                <span slot="unCheckedChildren" v-if="!model">
                  <i class="anticon anticon-cross"></i>
                </span>
              </v-switch>
            </div>`,
  data () {
    return {
      disabled: true
    }
  },
  props: ['model', 'label']
})

export default {
  name: 'AdminProgramsView',
  computed: {
    ...mapGetters([
      'allPrograms',
      'lov'
    ])
  },
  watch: {
    allPrograms: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getAllPrograms')
        }
      },
      immediate: true
    },
    lov: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getLov')
        }
      },
      immediate: true
    }
  },
  methods: {
    hideProgram (program) {
      this.$store.dispatch('updateProgram', {id: program.id, payload: {display_status: false}})
    },
    showProgram (program) {
      this.$store.dispatch('updateProgram', {id: program.id, payload: {display_status: true}})
    }
  },
  components: {
    ToggleSwitch
  }
}
</script>

<style scoped>

h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 34px;
}
.table {
  width: 100%;
  overflow: auto;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 15px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 13px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
  overflow: auto;
}
.trow .name {
  width: 18%;
}
.trow .school-name {
  width: 14%;
}
.trow .campus {
  width: 10%;
}
.trow .tution-fee {
  width: 10%;
}
.trow .application-fee {
  width: 10%;
}
.trow .september-intake {
  width: 9%;
}
.trow .january-intake {
  width: 7%;
}
.trow .may-intake {
  width: 4%;
}
.trow .actions {
  width: 18%;
  text-align: center;
}
.edit-button {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Programs/ProgramsView.vue